<template>
<div>
  <ViewerPc v-if="!isOnlyMobile()"></ViewerPc>
  <ViewerMobile v-else></ViewerMobile>
</div>
</template>

<script>
  import _ from 'lodash'
  // import App from "../App";
  import * as consts from '../constants';
  import ViewerMobile from "../pages/ViewerMobile";
  import ViewerPc from "../pages/ViewerPc";
  import router from '../router'
  

  export default {
    name: "Viewer",
    components: {ViewerMobile,ViewerPc},

    data() {
      return {
        
      }
    },

    mounted () {
        let workCode = this.$route.params.workCode
        let style = '<link rel="canonical" href="https://mangahot.jp/site/works/' + workCode + '">';
        $('head link:last').after(style);
    },

    beforeRouteLeave (to, from, next) {
        let restoreToken = this.$route.query.rt
        let timeres = this.$route.query.timeres
        if((restoreToken !== null || typeof restoreToken == 'undefined') && (timeres !== null || typeof timeres == 'undefined')){
            this.feedBackReadProgress();
        }
      next()
    },
    
  }
</script>




// WEBPACK FOOTER //
// src/pages/Viewer.vue